import { render, staticRenderFns } from "./AccumulationUseInfo.vue?vue&type=template&id=fd46bf8e&"
import script from "./AccumulationUseInfo.vue?vue&type=script&lang=ts&"
export * from "./AccumulationUseInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports